import { Card, Col } from "reactstrap";
import { Badges, Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicTableWithBorderBottomColor } from "../../../../Constant";
import { BASIC_TABLE_BODY, BASIC_TABLE_BPRDER_COLOR, BASIC_TABLE_HEAD } from "../../../../Data/BootstrapTable/BasicTable";
import CommonTable from "../Common/CommonTable";

const BasicTableBorderBottomColor = () => {
  return (
    <Col sm="12">
      <Card className="basicborder-table">
        <CommonCardHeader title={BasicTableWithBorderBottomColor} span={BASIC_TABLE_BPRDER_COLOR} table />
        <CommonTable headData={BASIC_TABLE_HEAD} headRowClass="border-bottom-primary">
          {BASIC_TABLE_BODY.map((data) => (
            <tr className={`border-bottom-${data.color}`} key={data.id}>
              <th scope="row">{data.id}</th>
              <td>
                <Image className="img-30 me-2" src={data.image} alt="users" body={true} />
                {data.firstname}
              </td>
              <td>{data.lastName}</td>
              <td>{data.userName}</td>
              <td>{data.designation}</td>
              <td>{data.company}</td>
              <td>
                <Badges color={`light-${data.badgeColor}`} className={`text-${data.badgeColor}`}>
                  {data.language}
                </Badges>
              </td>
              <td>{data.country}</td>
            </tr>
          ))}
        </CommonTable>
      </Card>
    </Col>
  );
};

export default BasicTableBorderBottomColor;
